import './styles/App.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "react-datepicker/dist/react-datepicker.css";
import { useContext, useEffect } from "react";
import MyRoutes from "./component/routes";
import { GlobalContext } from "./context/Context";
import AsideBar from "./component/layout/aside";
import { useApiCall } from './component/custom-hooks/api-call';
import axios from 'axios';
import InnerLoader from './component/ui/loader/inner-loader';
import { useLocation, useMatch } from 'react-router';

function App() {
  let { state, dispatch } = useContext(GlobalContext);
  const apiCall = useApiCall()

  const location = useLocation();

  const checkUser = async (userToken) => {
    
    let userData = JSON.parse(localStorage.getItem("userV3"));
    let saleToken = localStorage.getItem('saleToken');
    
    try {
      let apiRes = await apiCall({ url: 'check-user-time', method: 'get', customToken: userToken });
      let mainRole = (userData?.user_role == "1" || userData?.user_role == "2" || userData?.user_role == "3") ? "admin" : (userData.employee_role == "5" || userData.employee_role == "6") ? "lead" : "user";
      let subRole = (userData?.department == "13") ? "hr" : (userData.department == "14") ? "finance" : "";
      userData = { mainRole, subRole, ...userData }
      dispatch({ type: 'USER_LOGIN', payload: userData, token: userToken });
      dispatch({ type: "SALE_LOGIN", saleToken })
      getDropdowns(userToken);
      if (apiRes?.timeInEnabled == "yes") {
        dispatch({ type: 'TIME_OUT', payload: apiRes?.time_activity, hours: apiRes?.hrs });
      } else {
        dispatch({ type: 'TIME_IN', payload: apiRes?.time_activity });
      }
    } catch (error) {
      console.error("Error : ", error)
    }
  }

  const getDropdowns = async (token) => {
    try {
      let data = {}
      const [d1, d2, d3, d4, d5, d6] = await Promise.all([
        apiCall({ url: 'get-department-list', method: 'get', customToken: token }),
        apiCall({ url: 'get-active-employee-list', method: 'get', customToken: token }),
        apiCall({ url: 'get-employee-shift-list', method: 'get', customToken: token }),
        apiCall({ url: 'get-department-list-colours', method: 'get', customToken: token }),
        apiCall({ url: 'list-cover-picture', method: 'get', customToken: token }),
        apiCall({ url: 'hr/designations', method: 'get', customToken: token }),
      ]);
      data = {
        departmentList: d1?.departmentList,
        activeEmployeeList: d2?.activeEmployeeList,
        shiftList: d3?.shiftList,
        departColorList: d4?.depart_list,
        designationsList: d6?.designations,
      }
      dispatch({ type: "SET_DROPDOWN", payload: data })
      dispatch({ type: "UPDATE_COVERS", payload: d5.data })
    } catch (error) {
      console.error("Dropdown load error:", error);
    }
  };

  useEffect(() => {
    
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkTime();
      } else {
        // console.log("Tab is inactive (user left)");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // cleanup
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const checkTime = async() => {
    dispatch({ type: 'RESET_TIME' });
    let userToken = localStorage.getItem("tokenV3");
    try {
      let apiRes = await apiCall({ url: 'check-user-time', method: 'get', customToken: userToken });
      if (apiRes?.timeInEnabled == "yes") {
        dispatch({ type: 'TIME_OUT', payload: apiRes?.time_activity, hours: apiRes?.hrs });
      } else {
        dispatch({ type: 'TIME_IN', payload: apiRes?.time_activity });
      }
    } catch (error) {
      console.log("Error", error)
    }
  };

  useEffect(() => {
    let userToken = localStorage.getItem("tokenV3");
    const checkIsUserLogin = async () => {
      try {
        const apiRes = await axios.get('https://api.ipify.org?format=json');
        dispatch({ type: "SET_IP", payload: apiRes.data.ip })
        if (userToken) {
          checkUser(userToken)
        }else{
          if(location?.pathname != "/login"){
            sessionStorage.setItem("redirectUrl", `${location?.pathname}${location?.search}${location?.hash}`)
          }
          dispatch({ type: 'USER_LOGOUT' })
        }
      } catch (error) {
        
      }
    }
    checkIsUserLogin()
  }, [state.isLogin])

  const isPayslipPage = location.pathname.startsWith("/payroll/");

  return (
    <>
      {(state.isLogin == true && !isPayslipPage) ? (
        <main className="webPage">
          <AsideBar />
          <MyRoutes />
        </main>
      ) : (state.isLogin == false || isPayslipPage) ? (
        <MyRoutes />
      ) : (
        <div className="" style={{ height: "100vh", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {/* <CircularProgress sx={{ color: "#2563eb" }} size={100} /> */}
          <InnerLoader />
        </div>
      )
      }
      <div className="" style={{display: 'none'}}>
        {
          state?.coverPhotos?.map((eachPhoto) => (
            <img key={eachPhoto?.id} src={eachPhoto?.file_path} alt="" />
          ))
        }
      </div>

      <svg style={{display: 'none'}}>
        <filter
          id="glass-distortion"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.01 0.01"
            numOctaves="1"
            seed="5"
            result="turbulence"
          />

          <feComponentTransfer in="turbulence" result="mapped">
            <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
            <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
            <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
          </feComponentTransfer>

          <feGaussianBlur in="turbulence" stdDeviation="10" result="softMap" />

          <feSpecularLighting
            in="softMap"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="100"
            lightingColor="white"
            result="specLight"
          >
            <fePointLight x="-200" y="-200" z="300" />
          </feSpecularLighting>

          <feComposite
            in="specLight"
            operator="arithmetic"
            k1="0"
            k2="1"
            k3="1"
            k4="0"
            result="litImage"
          />

          <feDisplacementMap
            in="SourceGraphic"
            in2="softMap"
            scale="150"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </svg>
    </>
  );
}

export default App;
